import styled from 'styled-components';

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
`;

export const OptionCard = styled.label<{ $selected: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid ${({ $selected }) => ($selected ? '#005bd3' : '#e1e3e5')};
  background: ${({ $selected }) => ($selected ? '#eef4ff' : '#fff')};
  box-shadow: ${({ $selected }) => ($selected ? '0 0 0 1px #005bd3' : 'none')};
`;

export const OptionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SectionDivider = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin: 4px 0;

  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e1e3e5;
    margin-left: 10px;
  }
`;

export const LocaleModeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LocaleModeOption = styled.label<{ $selected: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid ${({ $selected }) => ($selected ? '#005bd3' : '#e1e3e5')};
  background: ${({ $selected }) => ($selected ? '#eef4ff' : '#fff')};
`;
